import {useEffect, useRef, useState} from 'react';
import SignatureCanvas from 'react-signature-canvas';
import {StyledSignature} from './BankSignature.styled';

export function Signature({ value, onChange, onBlur, className }) {

    const [sigPad, setSigPad] = useState(null);
    const [sizSize, setSizSize] = useState(null);
    const sigContainer = useRef();

    useEffect(() => {
        if (sigPad != null && (value == null || value === '')) {
            sigPad.clear();
        }
    }, [value]);

    useEffect(() => {
        if (sigContainer.current != null) {
            setSizSize({
                width: sigContainer.current.offsetWidth,
                height: sigContainer.current.offsetHeight
            });
        }
    }, [sigContainer]);

    function handleOnEnd() {
        const sig = sigPad.getCanvas().toDataURL('image/png');
        onChange(sig);
    }

    function handleMouseOut() {
        onBlur();
    }

    return (
        <StyledSignature className={className}>
            <div className="sigContainer" onMouseOut={handleMouseOut} ref={sigContainer}>
                {/* NOTE: line is far from cursor due to content scale (see: --main-scale-dektop: 0.9;) */}
                { sizSize != null && (
                    <SignatureCanvas
                        penColor='black'
                        canvasProps={{ width: sizSize.width, height: sizSize.height, className: 'sigCanvas'}}
                        ref={ref => setSigPad(ref)}
                        onEnd={() => handleOnEnd()}
                        backgroundColor='#F3F1FF'
                    />
                ) }
            </div>
        </StyledSignature>
    );
}
